import { combineReducers } from '@reduxjs/toolkit';
import mainContent from './mainContentSlice';
import categories from './categoriesSlice';
import levers from './leversSlice';
import general from './generalSlice';
import calibration from './calibrationSlice';
import errorManagement from './errorsSlice';
import metrics from './metricsSlice';
import display from './displaySlice';
import flows from './flowsSlice';
import endYear from './endYearSlice';

const pathwaysDomain = combineReducers({
  mainContent,
  categories,
  levers,
  general,
  calibration,
  errorManagement,
  metrics,
  display,
  flows,
  endYear,
});

export default pathwaysDomain;
